/**
 * 活動報名完整 URL（含短址優先、長網址 fallback）
 * 供 Join 送出分享、Hold 發佈分享、MainPage、SquareLandingPage 等處共用
 */

export interface BuildLiteJoinUrlParams {
  /** 活動報名短網址（後端 /g/:shortCode）；有則組出「前端網域/g/:shortCode」短網址 */
  shortUrl?: string | null;
  /** 前端 origin（組長網址與短網址用） */
  origin?: string;
  /** LINE 群組 ID（Group 脈絡） */
  groupId?: string | null;
  /** 商家 URL suffix（Square 脈絡） */
  suffix?: string | null;
  /** 活動 ID */
  activityId: string;
}

/** 從後端 shortUrl（如 https://api.example.com/g/621c790d）取出 shortCode */
function getShortCodeFromShortUrl(shortUrl: string): string | null {
  try {
    const path = new URL(shortUrl).pathname;
    const match = /\/g\/([^/?]+)/.exec(path);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

/**
 * 組出活動報名 URL：有 shortUrl 時為「前端網域/g/:shortCode」短網址，否則為前端長網址
 */
export function buildLiteJoinUrl(params: BuildLiteJoinUrlParams): string {
  const { shortUrl, origin = '', groupId, suffix, activityId } = params;
  const base = (
    origin || (typeof window !== 'undefined' ? window.location.origin : '')
  ).replace(/\/$/, '');
  const shortCode = shortUrl?.trim()
    ? getShortCodeFromShortUrl(shortUrl.trim())
    : null;
  if (shortCode) {
    return `${base}/g/${shortCode}`;
  }
  const encId = encodeURIComponent(activityId);
  if (suffix?.trim()) {
    return `${base}/lite/shop/${encodeURIComponent(suffix.trim())}/join/${encId}`;
  }
  if (groupId?.trim()) {
    return `${base}/lite/join?groupId=${encodeURIComponent(groupId.trim())}&activityId=${encId}`;
  }
  return `${base}/lite/join?activityId=${encId}`;
}
